import proptypes from 'prop-types';

const { string } = proptypes;

export const propTypes = {
  collectionName: string.isRequired
};